import {createFileRoute} from "@tanstack/react-router"
import {useTranslation} from "react-i18next";
import {Box, Divider, Stack, Typography} from "@mui/joy";
import {TileSpread} from "../../../components/Tile.tsx";
import {AgentPresenceTile} from "../../../agent/PresenceTile.tsx";
import {useActiveAgentPresences} from "../../../agent/presences.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

function ActiveAgentsPage() {
    const {t} = useTranslation();
    const allActivePresencesTqrv = useActiveAgentPresences();
    const allActivePresences = allActivePresencesTqrv.data;

    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <Stack direction="column" spacing={2}>
                <Divider>
                    <Typography level="h3" color="primary">{t("navi.admin.agentPresences")}</Typography>
                </Divider>
                {allActivePresences
                    ? <TileSpread foods={allActivePresences} estimatedHeight={120}
                                  Component={({food: presence}) =>
                                      <AgentPresenceTile presence={presence} key={presence.agent.id}/>}/>
                    : <Box>nobody home</Box>}
            </Stack>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/admin/active-agents")({
    component: ActiveAgentsPage,
})